import { create } from 'zustand';
import { DATA_TYPE, DATA_POINT_STATUS } from '../constants';
import { ValueOf } from 'src/utils/types';

// adjust import path

export type ProgressItem = {
  type: ValueOf<typeof DATA_TYPE>;
  status: ValueOf<typeof DATA_POINT_STATUS>
  [key: string]: any; // to hold modes or extra fields
};

type OnboardingStoreType = {
  activeScreen: string;
  setActiveScreen: (activeScreen: string) => void;
  currentDataType: string;
  setCurrentDataType: (currentDataType: string) => void;
  currentSubmissionMode: string;
  setCurrentSubmissionMode: (currentSubmissionMode: string) => void;
  isOnbDataLoading: boolean;
  setIsOnbDataLoading: (loading: boolean) => void;
  permissionScreen: string | null;
  postScreen: string | null;
  progress: ProgressItem[] | null;
  screenConfigs: any;

  setProgress: (progress: ProgressItem[] | null) => void;

  resetProgress: () => void;
  clearCollectionStore: () => void;

  hideHistoryBackPopup: boolean;
  setHideHistoryBackPopup: (hide: boolean) => void;

  isExitPopupOpen: boolean;
  setIsExitPopupOpen: (isOpen: boolean) => void;

  onbErrorMessage: string;
  setOnbErrorMessage: (onbErrorMessage: string) => void;
};

const useOnboardingStore = create<OnboardingStoreType>((set) => ({
  activeScreen: '',
  setActiveScreen: activeScreen => set({ activeScreen }),

  currentDataType: '',
  setCurrentDataType: currentDataType => set({ currentDataType }),

  currentSubmissionMode: '',
  setCurrentSubmissionMode: currentSubmissionMode =>
    set({ currentSubmissionMode }),

  isOnbDataLoading: false,
  setIsOnbDataLoading: loading => set({ isOnbDataLoading: loading }),

  onbErrorMessage: '',
  setOnbErrorMessage: onbErrorMessage => set({ onbErrorMessage }),
  permissionScreen: null,
  postScreen: null,
  progress: null,
  screenConfigs: null,

  setProgress: (progress: ProgressItem[] | null) => set({ progress }),

  resetProgress: () => {
    set({ progress: null });
  },

  clearCollectionStore: () => {
    set({
      permissionScreen: null,
      postScreen: null,
      progress: null,
      screenConfigs: null,
    });
  },

  hideHistoryBackPopup: false,
  setHideHistoryBackPopup: hideHistoryBackPopup => set({ hideHistoryBackPopup }),

  isExitPopupOpen: false,
  setIsExitPopupOpen: isExitPopupOpen => set({ isExitPopupOpen }),
}));

export default useOnboardingStore;
